export enum ControlSourceType {
    Quotation = 'Quotation',
    Sale = 'Sale'
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/types/control-source.type.ts